import React, { useState, useMemo } from "react";
import DynamicIcon from "../../Form/FormFields/DynamicIcon";
import CustomModal from "../CustomModal";

interface NoteProps {
  notes?: string | string[];
  modalTitle?: string;
}

const NoteComponent: React.FC<NoteProps> = ({ notes = [], modalTitle }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Normalize + split notes
  const notesArray = useMemo(() => {
    if (Array.isArray(notes)) {
      return notes
        .flatMap((note) => note.replace(/<br\\?>/gi, "\n").split("\n"))
        .map((n) => n.trim())
        .filter(Boolean);
    }

    if (typeof notes === "string" && notes.trim() !== "") {
      return notes
        .replace(/<br\\?>/gi, "\n")
        .split("\n")
        .map((n) => n.trim())
        .filter(Boolean);
    }

    return [];
  }, [notes]);

  return (
    <div className="inline-flex items-center align-middle">
      {/* Info Icon */}
      <div
        className="p-1 bg-blue-50 rounded-md cursor-pointer hover:bg-blue-100 transition-all border border-blue-100 group ml-2"
        onClick={(e) => {
          e.stopPropagation();
          setIsModalOpen(true);
        }}
        title="Click for details"
      >
        <DynamicIcon
          name="Info"
          className="w-3.5 h-3.5 text-blue-500 group-hover:text-blue-600"
        />
      </div>

      {/* Modal */}
      <CustomModal
        isOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
        title={`${modalTitle ?? "Notes"} Information`}
        size="sm"
      >
        <div className="p-2">
          <div className="space-y-4">
            <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-r-lg">
              <p className="text-sm text-blue-800 font-semibold mb-3">Notes</p>

              {notesArray.length > 0 ? (
                <div className="space-y-3">
                  {notesArray.map((note, index) => (
                    <div
                      key={index}
                      className="flex gap-3 items-start p-3 rounded-xl bg-white border border-blue-100 shadow-sm"
                    >
                      <span className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 border border-blue-300 flex items-center justify-center text-[11px] font-bold text-blue-700">
                        {index + 1}
                      </span>
                      <p className="text-[13px] text-slate-700 leading-relaxed">
                        {note}
                      </p>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-sm text-slate-500 italic text-center py-4">
                  No specific notes available.
                </p>
              )}
            </div>
          </div>
        </div>
      </CustomModal>
    </div>
  );
};

export default NoteComponent;
